module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._v("Features")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ece5881","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/overview/components/features_tab.vue
// module id = 1642
// module chunks = 180